document.querySelectorAll('*[data-hide-root]').forEach((el) => {
    new HideBase(el, 'hide', '*[data-hide-target]', null, parseInt(el.dataset.hideInit), el.dataset.hideAnimation);
})
document.querySelectorAll('input[data-mask]').forEach((el) => {
    if (el.dataset.mask === 'email') {
        el.IMask = new IMask.InputMask(el, {
            mask: 'w@w.w',
            blocks: {
                w: { mask: /\w+/g },
            },
        })
    } else if (el.dataset.mask === 'phone') {
        el.setAttribute('pattern', '^+7 ([0-9]{3}) [0-9]{3}-[0-9]{2}-[0-9]{2}$')
        el.IMask = new IMask.InputMask(el, {
            mask: [
                {
                    mask: '',
                    lazy: true,
                },
                {
                    mask: '+{7} (000) 000-00-00',
                    lazy: false,
                },
            ],
            blocks: {
                w: { mask: /\w+/g },
            },
        })
    } else {
        el.IMask = new IMask.InputMask(el, { lazy: false, ...el.dataset });
    }
})


class FiltersControl {
    constructor(el) {
        this.el = el;
    }

    setFilters(filters) {
        Object.entries(filters).forEach(([key, value]) => {
            const inputs = this.el.querySelectorAll(`.filters-container-block div:not([data-type-hidden]) input[name='${key}']`);
            if (!inputs.length) {
                if(key === 'line') {
                    this.setLineMetro(key, value);
                }
                else {
                    console.warn('filter not found', key);
                }
            }
            else {
                inputs.forEach((input) => {
                    this.setFilter(input, value, key);
                });
            }
        })
    }

    setLineMetro(key, value) {
        if(Array.isArray(value)) {
            value.forEach((val) => {
                document.querySelectorAll(`.MetroStationSelect[data-metro-index="${val}"] .MetroStationSelect__all input`).forEach((input) => {
                    input.checked = true;
                    input.dispatchEvent(new Event('change'));
                });
            });
        }
    }
    setFilter(input, value, key) {
        if(Array.isArray(value)) {
            return value.forEach((value) => {
                this.setFilter(input, value, key);
            });
        }

        const classNameParent = input.parentElement.className;
        const _is = (str) => classNameParent.includes(str);
        try {
            const isSelect = _is('SelectBase');
            if (_is('CheckboxTab__item') || _is('Checkbox') || _is('ToggleBase__item')) {
                this.setCheckbox(input, value);
            }
            else if (_is('DoubleInput__inputs') || isSelect || _is('InputBase') || _is('FilterPriceRange')) {
                this.setInput(input, value);
            }
            else if (_is('FilterTypeHouse')) {
                this.setTypeHouse(input, value);
            }
            else {
                console.warn('Not set filter', key, value, classNameParent);
            }
        }
        catch (e) {
            console.warn('Error set filter', key, e);
        }
    }

    setCheckbox(input, value) {
        const parent = input.parentElement.parentElement.parentElement;
        const isBoolean = parent.closest('.ToggleBoolean');
        parent.querySelectorAll('input').forEach((input) => {
            if(!value) {
                input.checked = false;
                if(!isBoolean) {
                    input.dispatchEvent(new Event('change'));
                }
            }
            else if(input.value === value.toString()) {
                input.checked = true;
                input.dispatchEvent(new Event('change'));
            }
        });
    }

    setInput(input, value = '') {
        if(input.addTag) {
            input.addTag(value);
        }
        else {
            input.value = value;
        }
        input.dispatchEvent(new Event('change'));
        input.dispatchEvent(new Event('set'));
    }

    setTypeHouse(input, value) {
        input.closest('.FilterTypeHouse').querySelector(`input[value='${value}']`).click();
    }
}

function setFilters(filters) {
    const control = new FiltersControl(document.querySelector('.main'));
    control.setFilters(filters);
}
function getCookieFilters() {
    return JSON.parse(CookieUtil.get(window.filtersCookieName) || '{}');
}
function setCookieFilters(filters) {
    CookieUtil.set(window.filtersCookieName, JSON.stringify(filters), filtersExpires, '/')
    document.dispatchEvent(new CustomEvent('main-filter-update', {detail: filters}));
}

function setOneCookieFilter(key, value) {
    const filters = getCookieFilters();
    filters[key] = value;
    setCookieFilters(filters);
}

window.isRestoringFilters = false;
function restoreFiltersFromCookie() {
    window.isRestoringFilters = true;
    const filters = getCookieFilters();
    resetMainFilters(filters);
    setTimeout(() => {
        window.isRestoringFilters = false;
    }, 1100);
}

function resetFiltersWithout(without = []) {
    const filtersOld = getCookieFilters();
    const filters = {};
    without.forEach((key) => {
        if(filtersOld[key]) {
            filters[key] = filtersOld[key];
        }
    });

    setCookieFilters(filters);
    setFilters(filters);
}

function resetMainFilters(filters={}) {
    if(!filters['general-type']) {
        filters['general-type'] = ['1'];
    }
    if(!filters['general-category']) {
        filters['general-category'] = ['5', '5_5'];
    }
    setCookieFilters(filters);
    setFilters(filters);

    if(!CookieUtil.get('user_region_id')) {
        citySet('Москва', 'n1i1');
    }
}

document.addEventListener('main-filter-change', ({detail}) => {
    if(window.isRestoringFilters) return;
    const {add, remove, change, name, value} = detail;
    let filters = getCookieFilters();
    let isChanged = true;

    if(remove) {
        if(value == null) {
            delete filters[name];
        }
        else if(Array.isArray(filters[name])) {
            filters[name] = filters[name].filter((item) => item != value);
        }
    }
    else if(add || change) {
        if(!Array.isArray(filters[name])) {
            filters[name] = [];
        }
        if(!~filters[name].indexOf(value) && value != null){
            filters[name].push(value);
        }
        else {
            isChanged = false;
        }
    }

    setCookieFilters(filters);
    if(isChanged) {
        checkChangeFilter(name, value, filters[name]);
    }
});

function isMainFilter(name, resetType = false) {
    return name === 'general-category' || (!resetType && (name === 'general-type' || name === 'general-commercial_type'));
}

function checkArrayInArray(arr1, arr2) {
    return arr1.some((item) => arr2.includes(item));
}

function checkChangeFilter(name, value, selected) {
    const resetGeneralType = (document.querySelector('.FilterTypeHouse').dataset.resetGeneralType || '').split(',');
    if(isMainFilter(name)) {
        if(name === 'general-category') {
            const allowValues = ['5', '5_5', '5_6'];
            if(allowValues.includes(value) && selected.every((item) => allowValues.includes(item))) {
                return;
            }
        }
        const filters = getCookieFilters();
        const isResetGeneralType = name === 'general-category' && checkArrayInArray(resetGeneralType, filters['general-category'] || []);
        let changed = false;
        const newFilters = Object.keys(filters).reduce((tmp, key) => {
            tmp[key] = isMainFilter(key, isResetGeneralType) ? filters[key] : undefined;
            changed = changed || tmp[key] !== filters[key];
            return tmp;
        }, {});
        if(changed) {
            setCookieFilters(newFilters);
            setFilters(newFilters);
        }

        document.querySelector('.IndexMainFilters__all-filters').scrollTo({top: 0});
        document.querySelector('.IndexMainFilters__other-btn[data-toggle]').dispatchEvent(new CustomEvent('close'));
    }
}

function citySet(name, value, setCookie = true) {
    if(setCookie) {
        CookieUtil.set('user_region_name', name, filtersExpires, '/');
        CookieUtil.set('user_region_id', value, filtersExpires, '/');
    }
    const btn = document.querySelector('.yes-modalyourcity');
    if(btn) {
        btn.dataset.name = name;
        btn.dataset.id = value;
    }
    if(name && setCookie && window.filtersMainAddFilter) {
        window.filtersMainAddFilter('search_address', value, name);
    }
}
